import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "is-flex is-align-items-center is-justify-content-space-between" }
const _hoisted_2 = ["disabled"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-play" })
], -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", null, "play", -1)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-stop" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "stop", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Cronometro = _resolveComponent("Cronometro")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Cronometro, { tempoEmSegundos: _ctx.tempoEmSegundos }, null, 8, ["tempoEmSegundos"]),
    _createElementVNode("button", {
      class: "button",
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.iniciar && _ctx.iniciar(...args))),
      disabled: _ctx.cronometroRodando
    }, _hoisted_5, 8, _hoisted_2),
    _createElementVNode("button", {
      class: "button",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.finalizar && _ctx.finalizar(...args))),
      disabled: !_ctx.cronometroRodando
    }, _hoisted_9, 8, _hoisted_6)
  ]))
}